* {
    box-sizing: border-box;
}

html,body {
    margin: 0;
    padding: 0;
    background-color: #fff;
    color: #000;
    overscroll-behavior: none;
    overflow-x: hidden;
}

#app {
    padding: 1.5em;
    padding-bottom: 4em;
    width: 100vw;
    height: 100vh;
}

html,body,input,button,select,textarea {
    font-family: "Roboto Slab", "Roboto Flex", "Roboto", system-ui, sans-serif;
    line-height: 1.5;
}

pre,code {
    font-family: "Roboto Mono", monospace;
}

.material-symbols-sharp {
    font-variation-settings: 'FILL' 0;
    font-size: 1em;
    vertical-align: middle;
}

button {
    cursor: pointer;
    font-weight: 600;
    appearance: none;
    border: 2px solid #000;
    background-color: transparent;
    padding: 0.45em 1.05em;
    font-size: .9em;
    display: inline-flex;
    align-items: center;
    gap: 0.2em;
}

button .material-symbols-sharp {
    font-size: 1.2em;  
}

button.primary {
    background-color: #000;
    color: #fff;
}

button.primary .material-symbols-sharp {
    font-variation-settings: 'FILL' 1;
}

button.nostyle {
    padding: 0;
    background-color: transparent;
    border: none;
}

input {
    font-size: 1em;
    padding: 0.2em 0.4em;
    border: 2px solid #000;
    outline: none;
}

::placeholder {
    color: #666;
}

img,
video {
    filter: brightness(0.9) contrast(1.7) grayscale(1);
}

a {
    cursor: pointer;
    color: inherit;
}

a:not(.nostyle) {
    color: #000;
    text-decoration: underline;
    text-decoration-thickness: 2px;
}

a:not(.nostyle):visited {
    color: #444;
}

a.nostyle {
    text-decoration: none;
}

p {
    margin: 0;
}


.custom-emoji {
    width: 1.2em;
    height: 1.2em;
    vertical-align: middle;
    object-fit: contain;
    margin: -0.2ex 0;
}

.page > h1, .notif-header > h1 {
    margin-block: .5rem;
    margin-bottom: 1rem;
}


::selection {
    background-color: #000;
    color: #fff;
}

.app-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #aaa;
    padding: 0;
    z-index: 1000;
}

.app-nav ul {
    display: flex;
    justify-content: space-around;
    list-style: none;
    margin: 0;
    padding: 0;
}

.app-nav li {
    font-size: 1.5em;
    padding: 0 0.5em;
    border-top: 3px solid transparent;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: calc(0.75em - 3px);
    padding-bottom: calc(0.75em + 3px);
}

.app-nav li.active {
    border-top: 3px solid #000;
}

.app-nav li.active .material-symbols-sharp {
    font-variation-settings: 'FILL' 1;
}

.app-nav a {
    text-decoration: none !important;
}

#post-fab {
    position: fixed;
    bottom: 2.5em;
    right: .5em;
    width: 2em;
    height: 2em;
    padding: 0;
    font-size: 2em;
    border: 1px solid white;
}

.app-nav li.compose-li {
   padding-top: .25em;
   padding-bottom: 0;
}
